module.exports = __webpack_public_path__ + "static/media/CC20-LC230-12.7e872d15.png";